import React from 'react';
import { useRef } from 'react';
export function traverseReactNode(children, fn) {
    let i = 0;
    function handle(target) {
        React.Children.forEach(target, (child) => {
            fn(child, i);
            i += 1;
        });
    }
    handle(children);
}
export function useInitialized(check) {
    const initializedRef = useRef(check);
    if (check) {
        initializedRef.current = true;
    }
    return !!initializedRef.current;
}
export function useShouldRender(active, forceRender, destroyOnClose) {
    const initialized = useInitialized(active);
    if (forceRender) {
        return true;
    }
    if (active) {
        return true;
    }
    if (!initialized) {
        return false;
    }
    return !destroyOnClose;
}
export const ShouldRender = (props) => {
    const shouldRender = useShouldRender(props.active, props.forceRender, props.destroyOnClose);
    return shouldRender ? props.children : null;
};
